import { GetCurrentUserResult } from "app/users/queries/getCurrentUser"
import { useCurrentUserFromContext } from "../providers/UserInfoProvider"

export const useCurrentUser = (): GetCurrentUserResult => {
  return useCurrentUserFromContext()
}
